/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ onlineCount: NonNullable<unknown>, totalCount: NonNullable<unknown>, plural: NonNullable<unknown> }} Network_Vehicles_Online_CountInputs */

const fr_network_vehicles_online_count = /** @type {(inputs: Network_Vehicles_Online_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.onlineCount}/${i?.totalCount} véhicule${i?.plural} en circulation`)
};

const en_network_vehicles_online_count = /** @type {(inputs: Network_Vehicles_Online_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.onlineCount}/${i?.totalCount} vehicle${i?.plural} in service`)
};

/**
* | output |
* | --- |
* | "{onlineCount}/{totalCount} vehicle{plural} in service" |
*
* @param {Network_Vehicles_Online_CountInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const network_vehicles_online_count = /** @type {((inputs: Network_Vehicles_Online_CountInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Network_Vehicles_Online_CountInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_network_vehicles_online_count(inputs)
	return en_network_vehicles_online_count(inputs)
});